/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudIcon16Solid = forwardRef('NetCloudIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.25 1.5a4.25 4.25 0 0 0-4.213 3.687A4.002 4.002 0 0 0 4.25 13h7a4.5 4.5 0 1 0-.125-8.998A4.25 4.25 0 0 0 7.25 1.5Z" })));
});
